let config = {};
let domain = window.location.hostname;

if (domain === 'business.cinch.io') {
  config.api_url = 'https://api.cinch.io';
  config.web_url = 'https://business.cinch.io';
  config.admin_url = 'https://business.cinch.io';
  config.developer_key = '--WEBRmfcyzgRpxrWEB--';
  config.adminVersion = 'admin/v1';
} else if (domain === 'business-staging.cinch.io') {
  config.api_url = 'https://api-staging.cinch.io';
  config.web_url = 'https://business-staging.cinch.io';
  config.admin_url = 'https://business-staging.cinch.io';
  config.developer_key = '--WEBRmfcyzgRpxrWEB--';
  config.adminVersion = 'admin/v1';
} else {
  config.api_url = 'https://sagacityapi.pxpqa.com';
  config.web_url = 'https://cinchadmin.pxpqa.com';
  config.admin_url = 'https://cinchadmin.pxpqa.com';
  config.developer_key = '--WEBRmfcyzgRpxrWEB--';
  config.adminVersion = 'admin/v1';
}

export default config;



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/